import {
  API_CAMPAIGN_REQUEST_ENDPOINT_V1,
  API_WIDGET_REQUEST_ENDPOINT_V1,
} from 'utils/constants';
import { appendQuery } from 'utils/http';
import { request } from '../http';
import {
  GetCampaignPreviewResponse,
  GetWidgetUnitsConfig,
  GetWidgetUnitsResponse,
} from './types';

export async function getWidgetUnits(
  widgetId: string,
  { url, q, sessionId, variantIdOverride }: GetWidgetUnitsConfig = {},
): Promise<GetWidgetUnitsResponse> {
  const apiUrl = appendQuery(API_WIDGET_REQUEST_ENDPOINT_V1, {
    q,
    sessionId,
    url,
    variantIdOverride,
    widgetId,
  });
  const { data } = await request.get(apiUrl);
  return data;
}

export async function getCampaignPreview(
  campaignFeedId: number,
): Promise<GetCampaignPreviewResponse> {
  const apiUrl = appendQuery(API_CAMPAIGN_REQUEST_ENDPOINT_V1, {
    campaignFeedId,
  });
  const { data } = await request.get(apiUrl);
  return data;
}
